/* 
 * @Author: 曹俊杰 
 * @Date: 2022-11-25 17:53:19
 * @Module: 级别下拉菜单
 */
 <template>
  <el-select :value="value" placeholder="请选择级别" clearable @change="change" style="width:100%;">
    <el-option v-for="item in ['A','B']" :key="item" :label="item" :value="item">
    </el-option>
  </el-select>
</template>
 <script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {};
  },
  mounted () { },
  methods: {
    change (value) {
      this.$emit('input', value)
    }
  },
};
 </script>
 <style lang='scss' scoped>
</style>